import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  uploadContent: {
    paddingBottom: '10rem',
  },
  dateRange: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  headerInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '5rem',
  },
  uploadButton: { margin: '0 auto 6rem' },
  removedFileName: { color: colors.neutral.black, margin: '0 0.5rem' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
